import React, { Component } from 'react';
import { AutoComplete, Popover } from 'antd';
import { Link, NavLink } from 'react-router-dom';
import { SvgIcon } from '../../common';
import './Header.scss';
 
const options = [
  { value: 'Burns Bay Road' },
  { value: 'Downing Street' },
  { value: 'Wall Street' },
];

const Horncontent = () => {
  return (
    <div></div>
  )
}


const FeedbackHorn = () => {
  return (
    <div className="bullhorn-header">
      <Popover content={Horncontent} trigger="click">
        <SvgIcon name="horn" viewbox="0 0 19.826 19.448" />
      </Popover>
    </div>
  )
}

class Header extends Component {
  state = { isActive: true };

  handleToggle = () => {
    this.setState({ isActive: !this.state.isActive });
  };
  render() {
    const isActive = this.state.isActive;
    return (
      <React.Fragment>
        <div className="main-header">
          <div className="header-inner">
            <nav className="header-nav">
              <div className={isActive ? "header-logo" : "header-logo show"}>
                <Link to="/home">
                  <SvgIcon name="logo" viewbox="0 0 180.124 50.271" />
                </Link>
              </div>
              <div className={isActive ? "hamburger" : "hamburger show"} onClick={this.handleToggle}>
                <span className="hline"></span>
                <span className="hline"></span>
                <span className="hline"></span>
              </div>
              <div className={isActive ? "header-menu dn-mob" : "header-menu"}>
                <NavLink to="/nodes" className="menu-item">
                  Nodes
                </NavLink>
                {/* <NavLink to="/providers" className="menu-item">
                  Providers
                </NavLink> */}
                <NavLink to="/validators" className="menu-item">
                  Validators
                </NavLink>
                <NavLink to="/blockchain" className="menu-item">
                  Blockchain
                </NavLink>
                <NavLink to="/governance" className="menu-item">
                  Governance
                </NavLink>
                <NavLink to="/market" className="menu-item">
                  Market
                </NavLink>
                <NavLink to="/utilities" className="menu-item">
                  Utilities
                </NavLink>
              </div>
            </nav>
            <FeedbackHorn />
            <div className="header-search">
              <SvgIcon className="search-icon" name="search" viewbox="0 0 17 16" />
              <AutoComplete
                style={{ width: 180 }}
                options={options}
                placeholder="Search for nodes.."
                filterOption={(inputValue, option) =>
                  option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
              />  
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

 
export default Header
